// extracted by mini-css-extract-plugin
export default {"search-bar":"search-bar_search-bar__O2bLR"};